import { render, staticRenderFns } from "./MailTemplateInfo.vue?vue&type=template&id=8cfc132e&"
import script from "./MailTemplateInfo.vue?vue&type=script&lang=ts&"
export * from "./MailTemplateInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports